<template>
  <div class="order-detail-page" @scroll="onScroll" ref="scrollContainer">
    <div class="fixed-header">
      <div class="nav-top">
        <i class="el-icon-arrow-left" @click="$router.back()"></i>
        <span class="title">订单详情</span>
        <i class="el-icon-more"></i>
      </div>
      <div class="tabs-container">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          :class="['tab-item', { active: activeTab === index }]"
          @click="scrollToSection(index)"
        >
          {{ tab }}
          <div class="line" v-if="activeTab === index"></div>
        </div>
      </div>
    </div>

    <div class="content-body" v-loading="loading">
      <section class="detail-card" id="section-0" ref="section0">
        <div class="card-header">
          <span class="title">基础信息</span>
          <div class="tags">
            <span class="tag" :class="getStatusClass(orderInfo.orderstate)">{{ orderInfo.orderstate }}</span>
          </div>
        </div>
        <div class="info-list">
          <div class="info-item"><label>订单ID</label><span>{{ orderInfo.ordernumber || '-' }}</span></div>
          <div class="info-item"><label>创建时间</label><span>{{ orderInfo.createtime || orderInfo.createTime || '-' }}</span></div>
          <div class="info-item"><label>场站</label><span>{{ orderInfo.parkAddress || orderInfo.plotName || '-' }}</span></div>
          <div class="info-item"><label>充电桩名称</label><span>{{ orderInfo.pileName || '-' }}</span></div>
          <div class="info-item"><label>端口名称</label><span>{{ orderInfo.portName || orderInfo.deviceid || '-' }}</span></div>
          <div class="info-item"><label>规则ID</label><span>{{ orderInfo.wxRuleId || '-' }}</span></div>
          <div class="info-item" v-if="ruleDetail.changeName"><label>规则名称</label><span>{{ ruleDetail.changeName }}</span></div>
        </div>
      </section>

      <section class="detail-card" id="section-1" ref="section1">
        <div class="card-header">
          <span class="title">费用明细</span>
        </div>
        <div class="info-list">
          <div class="info-item bold">
            <label>订单总额 (元)</label>
            <span class="val">{{ formatPrice(orderInfo.orderGold || orderInfo.price) }}</span>
          </div>
          <div class="info-item">
            <label>充电费 (元)</label>
            <span>{{ formatPrice(orderInfo.chargeFee) }}</span>
          </div>
          <div class="info-item">
            <label>服务费 (元)</label>
            <span>{{ formatPrice(orderInfo.serviceFee) }}</span>
          </div>
          <div class="info-item" v-if="orderInfo.couponDiscountVal > 0">
            <label>优惠券优惠 (元)</label>
            <span>-{{ formatPrice(orderInfo.couponDiscountVal) }}</span>
          </div>
          <div class="info-item" v-if="orderInfo.plotDiscountVal > 0">
            <label>站点优惠 (元)</label>
            <span>-{{ formatPrice(orderInfo.plotDiscountVal) }}</span>
          </div>
          <div class="info-item">
            <label>用户实付金额 (元)</label>
            <span class="val">{{ formatPrice(orderInfo.orderGold || orderInfo.price) }}</span>
          </div>
        </div>
      </section>

      <section class="detail-card" id="section-2" ref="section2">
        <div class="card-header"><span class="title">用户信息</span></div>
        <div class="info-list">
          <div class="info-item"><label>用户名</label><span>{{ orderInfo.userName || '-' }}</span></div>
          <div class="info-item">
            <label>手机号</label>
            <span class="val-blue"><i class="el-icon-phone-outline"></i> {{ orderInfo.mobile || '-' }}</span>
          </div>
          <div class="info-item"><label>车牌号</label><span>{{ orderInfo.plateNum || orderInfo.carPlat || '-' }}</span></div>
          <div class="info-item" v-if="userDetail.sumAmount"><label>账户余额</label><span>¥{{ userDetail.sumAmount }}</span></div>
          <div class="info-item" v-if="userDetail.userType !== undefined"><label>用户类型</label><span>{{ getUserTypeText(userDetail.userType) }}</span></div>
        </div>
      </section>

      <section class="detail-card" id="section-3" ref="section3">
        <div class="card-header"><span class="title">充电信息</span></div>
        <div class="info-list">
          <div class="info-item">
            <label>充电量 (度)</label>
            <span>{{ orderInfo.consumePower || '0' }}</span>
          </div>
          <div class="info-item">
            <label>充电时长 (小时)</label>
            <span>{{ orderInfo.hour || orderInfo.realHour || '0' }}</span>
          </div>
          <div class="info-item">
            <label>开始时间</label>
            <span>{{ orderInfo.starttime || orderInfo.startTime || '-' }}</span>
          </div>
          <div class="info-item">
            <label>结束时间</label>
            <span>{{ orderInfo.endtime || orderInfo.endTime || '-' }}</span>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getOrderDetails, getOrderDetails2, getOrderTrack, getUserList, getRule } from "@/api/newApi";

export default {
  data() {
    return {
      activeTab: 0,
      tabs: ['基础信息', '费用明细', '用户信息', '充电信息'],
      isManualScrolling: false,
      orderInfo: {},
      orderTrace: [],
      userDetail: {},
      ruleDetail: {},
      loading: false
    };
  },
  mounted() {
    this.getOrderDetail();
    this.getOrderTrace();
  },
  methods: {
    async getOrderDetail() {
      this.loading = true;
      try {
        console.log('route.query:', this.$route.query);
        const orderNumber = this.$route.query.orderNumber || this.$route.query.id;
        console.log('请求订单详情, orderNumber:', orderNumber);
        if (!orderNumber) {
          console.error('orderNumber为空，请检查路由参数');
          this.loading = false;
          return;
        }
        const res = await getOrderDetails2({ orderNumber });
        console.log('订单详情原始返回:', res);
        console.log('订单详情res.data:', res.data);
        console.log('订单详情res.data.data:', res.data ? res.data.data : 'res.data is null');
        if (res.data && res.data.data) {
          const data = res.data.data;
          console.log('订单详情数据:', data);
          console.log('userName:', data.userName);
          console.log('userTelephoneNo:', data.userTelephoneNo);
          this.orderInfo = {
            ...data,
            ordernumber: data.orderNumber,
            orderstate: this.convertOrderState(data.orderState),
            mobile: data.userTelephoneNo,
            portName: data.pilePortName,
            plotName: data.address,
            realHour: data.realHour,
            startTime: data.startTime,
            endTime: data.realEndTime,
            createTime: data.createTime,
            orderTrace: data.logList || [],
            plateNum: data.plateNum,
            carPlat: data.carPlat,
            wxRuleId: data.wxRuleId
          };
          console.log('orderInfo设置后:', this.orderInfo);
          if (data.logList && data.logList.length > 0) {
            this.orderTrace = data.logList;
          }
          if (data.userTelephoneNo) {
            this.getUserDetail(data.userTelephoneNo);
          }
          if (data.wxRuleId) {
            this.getRuleDetail(data.wxRuleId);
          }
        } else if (res.data && !res.data.data) {
          // 可能是直接返回data没有嵌套
          const data = res.data;
          console.log('订单详情数据(无嵌套):', data);
          this.orderInfo = {
            ...data,
            ordernumber: data.orderNumber,
            orderstate: this.convertOrderState(data.orderState),
            mobile: data.userTelephoneNo,
            portName: data.pilePortName,
            plotName: data.address,
            realHour: data.realHour,
            startTime: data.startTime,
            endTime: data.realEndTime,
            createTime: data.createTime,
            orderTrace: data.logList || [],
            plateNum: data.plateNum,
            carPlat: data.carPlat,
            wxRuleId: data.wxRuleId
          };
          if (data.logList && data.logList.length > 0) {
            this.orderTrace = data.logList;
          }
          if (data.userTelephoneNo) {
            this.getUserDetail(data.userTelephoneNo);
          }
          if (data.wxRuleId) {
            this.getRuleDetail(data.wxRuleId);
          }
        } else {
          console.warn('res.data为空');
        }
      } catch (err) {
        console.log('获取订单详情失败', err);
      } finally {
        this.loading = false;
      }
    },
    convertOrderState(state) {
      const stateMap = {
        1: '已下单',
        2: '已取消',
        3: '已支付',
        4: '已退款',
        5: '已完成'
      };
      return stateMap[state] || '未知';
    },
    formatPrice(val) {
      if (val === null || val === undefined || val === '') return '0.00';
      return Number(val).toFixed(2);
    },
    async getUserDetail(mobile) {
      try {
        const res = await getUserList({ keyWord: mobile, pageNo: 1, pageSize: 1 });
        console.log('用户信息返回:', res);
        let userData = res.data;
        // 处理可能的双层嵌套 res.data.data
        if (res.data && res.data.data && Array.isArray(res.data.data.records)) {
          userData = res.data.data;
        }
        if (userData && userData.records && userData.records.length > 0) {
          this.userDetail = userData.records[0];
          console.log('用户详情:', this.userDetail);
        }
      } catch (err) {
        console.log('获取用户信息失败', err);
      }
    },
    getUserTypeText(type) {
      const typeMap = { 0: '小程序', 1: 'IC卡', 2: '其他' };
      return typeMap[type] || '未知';
    },
    async getRuleDetail(ruleId) {
      try {
        const res = await getRule({ id: ruleId });
        console.log('规则详情返回:', res);
        let ruleData = res.data;
        if (res.data && res.data.data) {
          ruleData = res.data.data;
        }
        if (ruleData) {
          this.ruleDetail = ruleData;
          console.log('规则详情:', this.ruleDetail);
        }
      } catch (err) {
        console.log('获取规则详情失败', err);
      }
    },
    async getOrderTrace() {
      try {
        const orderNumber = this.$route.query.orderNumber || this.$route.query.id;
        const res = await getOrderTrack({ orderNumber });
        console.log('订单轨迹返回:', res);
        let traceData = res.data;
        if (res.data && res.data.data && Array.isArray(res.data.data)) {
          traceData = res.data.data;
        }
        if (traceData && traceData.length > 0) {
          this.orderTrace = traceData.map(item => ({
            ...item,
            createTime: item.createTime ? this.formatTime(item.createTime) : ''
          }));
        }
      } catch (err) {
        console.log('获取订单轨迹失败', err);
      }
    },
    formatTime(time) {
      if (!time) return '';
      if (typeof time === 'string') return time;
      const d = new Date(time);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hour = String(d.getHours()).padStart(2, '0');
      const minute = String(d.getMinutes()).padStart(2, '0');
      const second = String(d.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    getStatusClass(status) {
      const statusMap = {
        '已完成': 'green',
        '已支付': 'green',
        '已下单': 'blue',
        '已取消': 'gray',
        '结算中': 'blue',
        '手动结算': 'gray',
        '已退款': 'orange'
      };
      return statusMap[status] || 'gray';
    },
    onScroll() {
      if (this.isManualScrolling) return;
      const container = this.$refs.scrollContainer;
      const scrollPos = container.scrollTop + 120;
      for (let i = 0; i < this.tabs.length; i++) {
        const section = document.getElementById(`section-${i}`);
        if (section) {
          const offsetTop = section.offsetTop;
          const offsetHeight = section.offsetHeight;
          if (scrollPos >= offsetTop && scrollPos < offsetTop + offsetHeight) {
            this.activeTab = i;
            break;
          }
        }
      }
    },
    scrollToSection(index) {
      this.activeTab = index;
      this.isManualScrolling = true;
      const section = document.getElementById(`section-${index}`);
      if (section) {
        this.$refs.scrollContainer.scrollTo({
          top: section.offsetTop - 100,
          behavior: 'smooth'
        });
      }
      setTimeout(() => { this.isManualScrolling = false; }, 800);
    }
  }
};
</script>

<style lang="scss" scoped>
.order-detail-page {
  background-color: #F6F8FA;
  height: 100vh;
  overflow-y: auto;
  padding-top: 95px;
}

.fixed-header {
  position: fixed;
  top: 0; left: 0; right: 0;
  background: #FFF;
  z-index: 1000;
  .nav-top {
    display: flex;
    justify-content: space-between;
    padding: 15px 16px;
    align-items: center;
    .title { font-size: 18px; font-weight: bold; }
    i { font-size: 20px; }
  }
  .tabs-container {
    display: flex;
    overflow-x: auto;
    padding: 0 10px;
    &::-webkit-scrollbar { display: none; }
    .tab-item {
      flex-shrink: 0;
      padding: 10px 15px;
      font-size: 14px;
      color: #999;
      position: relative;
      &.active {
        color: #333;
        font-weight: bold;
        .line {
          position: absolute;
          bottom: 5px;
          left: 25%;
          width: 50%;
          height: 3px;
          background: #00BFA5;
          border-radius: 2px;
        }
      }
    }
  }
}

.detail-card {
  background: #FFF;
  margin: 12px 16px;
  border-radius: 12px;
  padding: 16px;
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    .title { font-size: 16px; font-weight: bold; color: #333; }
    .action-blue { color: #00BFA5; font-size: 14px; }
    .tags {
      display: flex;
      gap: 5px;
      .tag {
        font-size: 11px;
        padding: 2px 6px;
        border-radius: 4px;
        &.green { background: #E8F9ED; color: #52C41A; }
        &.blue { background: #E6F7FF; color: #1890FF; }
        &.orange { background: #FFF7E6; color: #FF9500; }
        &.gray { background: #F5F5F5; color: #999; }
      }
    }
  }
}

.timeline {
  .time-node {
    display: flex;
    gap: 15px;
    align-items: center;
    .icon {
      width: 22px; height: 22px;
      background: #DDD;
      color: #FFF;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
    }
    &.active .icon {
      background: #00BFA5;
    }
    .node-content {
      flex: 1;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #333;
      .time { color: #999; font-size: 13px; }
    }
  }
  .line {
    width: 2px; height: 20px;
    background: #00BFA5;
    margin-left: 10px;
  }
  .empty-tip {
    text-align: center;
    color: #999;
    padding: 20px 0;
  }
}

.info-list {
  .info-item {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    font-size: 14px;
    label { color: #999; i { font-size: 14px; margin-left: 2px; } }
    span { color: #333; text-align: right; word-break: break-all; max-width: 70%; }
    &.bold { font-weight: bold; }
    .val-blue { color: #00BFA5; }
  }
}
</style>